<template>
    <div>
        <AirInfoWin v-show="false"
                    v-on:loaded-air-info="loadedAirInfoHandle"
                    ref="airInfoWin" />
        <RainfallInfoWin v-show="false"
                    v-on:loaded-rainfall-info="loadedRainfallInfoHandle"
                    ref="rainfallInfoWin" />
        <MediumMosqWin v-show="false"
                    v-on:loaded-medium-mosq-info="loadedMediumMosqInfoHandle"
                    ref="mediumMosqWin" />
        <MediumMosqInfoWin v-show="selectedSubMenu === 'mediumMosq' && selectedTopMenu === 'Air' && !this.isMobile" />
        <MediumMosqActInfoWin v-show="selectedSubMenu === 'mediumMosq' && selectedTopMenu === 'Air' && !this.isMobile" />
    </div>
</template>

<script>
import { $_TYPE, $_WC, $_ADM } from '@/confs/common.const';
import naverMapShareMixins from '@/stores/naver.map.share.mixin';
import { mapGetters } from "vuex";
import gripUtil from "@/libs/grip.util";
import airLevel from "@/libs/air.level.js";
import AirInfoWin from "@/views/realtime/AirInfoWin.vue";
import RainfallInfoWin from "@/views/realtime/RainfallInfoWin.vue";
import MediumMosqInfoWin from "@/views/realtime/MediumMosqInfoWin.vue";
import MediumMosqWin from "@/views/realtime/MediumMosqWin.vue";
import MediumMosqActInfoWin from "@/views/realtime/MediumMosqActInfoWin.vue";


export default {
    components:{
        AirInfoWin,
        RainfallInfoWin,
        MediumMosqInfoWin,
        MediumMosqWin,
        MediumMosqActInfoWin,
    },
    data(){
        return {
            groupName: 'Air',
        };
    },
    computed: {
        ...mapGetters({
            selectedTopMenu: 'getSelectedTopMenu',
            selectedSubMenus: 'getSelectedSubMenus',
            subMenuList: 'getSubMenuList',
            airHjdMeta: 'getAirHjdMeta',
            airHjdSensorList: 'getAirHjdSensorList',
            rainfallMap: 'getRainfallMap',
            waterLevelList: 'getWaterLevelList',
            mosquitoList: 'getMosquitoList',
            mosquitoHjdMap: 'getMosquitoHjdMap',
            disWaterList: 'getDisWaterList',
            dongRainfallInfo:'getDongRainfallInfo',
            mediumMosqList: 'getMediumMosqList',
            selectedSubMenu: 'getSelectedSubMenu',
        }),
        airHjdSensorMap() {
            return gripUtil.toDict(this.airHjdSensorList, 'addongHjbCd');
        },
        subMenuInfo() {
            let subMap = gripUtil.toDict(this.subMenuList[this.selectedTopMenu], 'code');
            return subMap;
        },
        mosquitoRank() {
            let hjdMap = this.mosquitoHjdMap;
            let list = gripUtil.toList(hjdMap);
            let topRate = (list.length*25) / 100;
            let midTopRate = (list.length*50) / 100;
            let midLowRate = (list.length*75) / 100;

            list = list.sort((pre, cur) =>{
                return cur.cnt - pre.cnt;
            });

            list.forEach((data, index) =>{
                let dongNm = data.hjd;
                let rank  = Number(index + 1);
                data.rank = rank;
                hjdMap[dongNm].rank = rank;
                // 25%
                if( Number(rank) <= Number(topRate)) {
                    hjdMap[dongNm].rankNm = 'worse';
                }
                // 25 ~ 50%
                if( Number(rank) > Number(topRate) && Number(rank) <= Number(midTopRate)) {
                    hjdMap[dongNm].rankNm = 'bad';
                }
                // 50 ~ 75%
                if( Number(rank) > Number(midTopRate) && Number(rank) <= Number(midLowRate)) {
                    hjdMap[dongNm].rankNm = 'normal';
                }
                // 75% ~
                if(Number(rank) > Number(midLowRate) ) {
                    hjdMap[dongNm].rankNm = 'good';
                }

            });
            return hjdMap;
        },
        isMobile() {
            let isMobile = $_WC.isMobile;
            return isMobile;
        },
    },
    watch: {
        selectedSubMenus: {
            immediate: false,
            handler(newVal, oldVal) {
                this.placeMarkers();
            }
        },
        airHjdSensorList: {
            immediate: false,
            handler: function (newVal, oldVal) {
                this.placeMarkers();
            }
        },
        rainfallMap: {
            immediate: false,
            handler: function (newVal, oldVal) {
                if(typeof this.$route.query['sCode'] !== $_TYPE.UNDEF && this.$route.query['sCode'] === 'rain') {
                    this.placeMarkers();
                }
            }
        },
        // dongRainfallInfo: {
        //     immediate: false,
        //     handler: function (newVal, oldVal) {
        //         if(typeof this.$route.query['sCode'] !== $_TYPE.UNDEF && this.$route.query['sCode'] === 'rain') {
        //             this.placeMarkers();
        //         }
        //     }
        // },
        waterLevelList: {
            immediate: false,
            handler: function (newVal, oldVal) {
                if(typeof this.$route.query['sCode'] !== $_TYPE.UNDEF && this.$route.query['sCode'] === 'rain') {
                    this.placeMarkers();
                }
            }
        },
    },
    created() {
    },
    methods: {
        placeMarkers(){
            if(typeof this.geoJsonDrawing !== $_TYPE.UNDEF) {
                if (this.selectedTopMenu === 'Air') {
                    this.removeMarker(this.groupName);
                    let selectedSubMenu = this.selectedSubMenus[0];
                    this.$store.dispatch('SET_SELECTED_SUB_MENU', selectedSubMenu);
                    let airQaMeta = this.airHjdMeta[selectedSubMenu];

                    if(selectedSubMenu !== 'rain' && selectedSubMenu !== 'mosquito' && selectedSubMenu !== 'mediumMosq') {
                        this.geoJsonDrawing.setOptionAll("fillColor", "#96989B");
                        for (let addongCd in $_ADM.ADDONG_CENTER_MAP) {
                            let dongNm = $_ADM.ADDONG_CENTER_MAP[addongCd].dongNm;
                            let lat = $_ADM.ADDONG_CENTER_MAP[addongCd].lat;
                            let lng = $_ADM.ADDONG_CENTER_MAP[addongCd].lng;
                            let umdAir = this.airHjdSensorMap[addongCd];
                            if (typeof umdAir !== $_TYPE.UNDEF) {
                                let val = umdAir[airQaMeta.valCol];
                                if(selectedSubMenu == 'o3') {
                                    val = val.toFixed(3);
                                } else if(selectedSubMenu == 'no2') {
                                    val = val.toFixed(3);
                                }
                                let qa = airQaMeta.levelFun.call(airLevel, val);
                                this.geoJsonDrawing.setFillColor(addongCd, qa[3]);

                                let htmlMarker = this.makeHtmlMarker(dongNm, val, airQaMeta.unit, qa[0]);
                                let marker = new naver.maps.Marker({
                                    position: new naver.maps.LatLng(lat, lng),
                                    map: this.map,
                                    title: dongNm,
                                    icon: {
                                        content: htmlMarker,
                                        size: new naver.maps.Size(240, 240),
                                        anchor: new naver.maps.Point(30, 30),
                                    },
                                });
                                let measureTime = umdAir.basdtVal;

                                let dongAirInfo = {
                                    hjdNm: dongNm,
                                    hjdCd: addongCd,
                                    airTypeNm: airQaMeta.name,
                                    airType: selectedSubMenu,
                                    val: val,
                                    level: qa,
                                    unit: airQaMeta.unit,
                                    fillColor: qa[0],
                                    measureTime: measureTime,
                                };

                                naver.maps.Event.addListener(marker, 'click', (event) => {
                                    this.$store.dispatch("SET_SELECTED_MARKER", marker);
                                    this.$refs.airInfoWin.setDongAirInfo(dongAirInfo);
                                });
                                this.addMarkerMap(this.groupName, marker);
                                umdAir.marker = marker;
                            }
                        }
                    } else if(selectedSubMenu === 'mosquito') {
                            this.removeMarker(this.groupName);
                            this.geoJsonDrawing.setOptionAll('fillColor', '#96989B');
                            let legdongNmMap = $_ADM.LEGDONG_NM_MAP;
                            let mosquitoMap = this.mosquitoRank;
                            let mosquitoQaHtml = '';
                            let val = '';
                            let level = '';

                            for(let key in legdongNmMap) {
                                if(typeof mosquitoMap[key] !== $_TYPE.UNDEF) {
                                    let dongCd = legdongNmMap[key];
                                    let mosquito = mosquitoMap[key];

                                    let position = $_ADM.LEGDONG_CENTER_MAP[dongCd];
                                    val = mosquito.cnt;
                                    level = mosquito.rankNm;

                                    mosquitoQaHtml = this.makeHtmlMarker(key, val.toLocaleString(), '건', level);
                                    var marker = new naver.maps.Marker({
                                        position: new naver.maps.LatLng(position.lat, position.lng),
                                        map: this.map,
                                        title: key,
                                        icon: {
                                            content: mosquitoQaHtml,
                                            size: new naver.maps.Size(240, 240),
                                            anchor: new naver.maps.Point(30, 30),
                                        },
                                    });
                                    this.addMarkerMap(this.groupName, marker);
                                    // this.markerMap[this.groupName].push(marker);
                                }
                            }
                    } else if(selectedSubMenu === 'mediumMosq') {
                        this.removeMarker(this.groupName);
                        this.geoJsonDrawing.setOptionAll("fillColor", "#b0b0b0");
                        let mediumMosqList = this.mediumMosqList;
                        if(typeof mediumMosqList !== 'undefined') {
                            mediumMosqList.forEach(d => {
                                let measureTime = d.basdtVal+' '+d.val11;
                                let lat = d.lttdVal;
                                let lng = d.lgtdVal;
                                let val = Number(d.val4);
                                let level = '';
                                let key = d.val2;
                                if(val >= 0 && val < 25) {
                                    level = 'normal';
                                } else if (val >= 25 && val < 50) {
                                    level = 'good';
                                } else if (val >= 50 && val < 75) {
                                    level = 'bad';
                                } else {
                                    level = 'worse';
                                }

                                let htmlMarker = this.makeHtmlMarker(key, val, '마리', level);
                                let marker = new naver.maps.Marker({
                                    position: new naver.maps.LatLng(lat, lng),
                                    map: this.map,
                                    title: key,
                                    icon: {
                                        content: htmlMarker,
                                        size: new naver.maps.Size(240, 240),
                                        anchor: new naver.maps.Point(30, 30),
                                    },
                                });

                                //추가 시작
                                let mediumMosqInfo = {
                                    hjdNm: key,
                                    airTypeNm: '매개모기',
                                    val: val,
                                    level: level,
                                    unit: '마리',
                                    measureTime: measureTime,
                                    dottedMos: d.val5,
                                    redMos: d.val6,
                                    goldMos: d.val7,
                                    whiteMos: d.val8,
                                    etcMos: d.val9,
                                    mediumMosq: d.val10,
                                    type : 'mediumMosq',
                                };

                                naver.maps.Event.addListener(marker, 'click', (event) => {
                                    this.$store.dispatch("SET_SELECTED_MARKER", marker);
                                    this.$store.dispatch("SET_SELECTED_ME_MOSQ", d);
                                    this.$refs.mediumMosqWin.setMediumMosqInfo(mediumMosqInfo);
                                    // this.$refs.rainfallInfoWin.setRainfallInfo(rainfallInfo);
                                });
                                this.addMarkerMap(this.groupName, marker);
                                d.marker = marker;
                                //추가 종료

                                // this.addMarkerMap(key, marker);
                            })
                        }
                    } else {
                        this.removeMarker(this.groupName);
                        this.geoJsonDrawing.setOptionAll("fillColor", "#b0b0b0");
                        // 강우량
                        // console.log(this.rainfallMap, this.waterLevelList);
                        for(let name in this.dongRainfallInfo) {
                            let lat = this.dongRainfallInfo[name].lttdVal;
                            let lng = this.dongRainfallInfo[name].lgtdVal;
                            let lastestVal = this.dongRainfallInfo[name].lastestVal;
                            let val = this.dongRainfallInfo[name].threeHourSum;
                            let measureTime = this.dongRainfallInfo[name].basdtVal;

                            let curLevel = airQaMeta.levelFun.call(airLevel, lastestVal);
                            let qa = airQaMeta.levelFun.call(airLevel, val);

                            let htmlMarker = this.makeHtmlMarker(name, val, airQaMeta.unit, qa[0], '강우량');
                            let marker = new naver.maps.Marker({
                                position: new naver.maps.LatLng(lat, lng),
                                map: this.map,
                                title: name,
                                icon: {
                                    content: htmlMarker,
                                    size: new naver.maps.Size(240, 240),
                                    anchor: new naver.maps.Point(30, 30),
                                },
                            });

                            let rainfallInfo = {
                                hjdNm: name,
                                airTypeNm: airQaMeta.name,
                                airType: selectedSubMenu,
                                val: val,
                                level: qa,
                                curLevel: curLevel,
                                unit: airQaMeta.unit,
                                valObj : this.dongRainfallInfo[name],
                                measureTime: measureTime,
                                type : 'rain',
                            };

                            naver.maps.Event.addListener(marker, 'click', (event) => {
                                this.$store.dispatch("SET_SELECTED_MARKER", marker);
                                this.$refs.rainfallInfoWin.setRainfallInfo(rainfallInfo);
                            });
                            this.addMarkerMap(this.groupName, marker);
                            this.dongRainfallInfo[name].marker = marker;
                        }

                        // 하천수위
                        // 자료종류 1870 추가
                        // let disWaterList = this.disWaterList;
                        let newWaterLevelList = [];
                        // if(typeof disWaterList !== 'undefined') {
                        //     newWaterLevelList = this.waterLevelList.concat(disWaterList);
                        // }
                        newWaterLevelList = this.waterLevelList;
                        newWaterLevelList.forEach((d)=>{
                        // this.waterLevelList.forEach((d)=>{
                            let cd = d.val1;
                            console.log('d', d);
                            if(typeof $_ADM.WATER_LEVEL_LOC_MAP[cd] !== $_TYPE.UNDEF) {
                                let lat = $_ADM.WATER_LEVEL_LOC_MAP[cd].lat;
                                let lng = $_ADM.WATER_LEVEL_LOC_MAP[cd].lng;
                                let name = d.val2;
                                let val = d.val6;
                                let limit = d.val8;
                                let measureTime = d.basdtVal;
                                let qa = airLevel.waterLevel(val, limit);

                                let htmlMarker = this.makeHtmlMarker(name, val, airQaMeta.unit, qa[0], '하천수위');
                                let marker = new naver.maps.Marker({
                                    position: new naver.maps.LatLng(lat, lng),
                                    map: this.map,
                                    title: name,
                                    icon: {
                                        content: htmlMarker,
                                        size: new naver.maps.Size(240, 240),
                                        anchor: new naver.maps.Point(30, 30),
                                    },
                                });

                                let rainfallInfo = {
                                    hjdNm: name,
                                    airTypeNm: '하천수위',
                                    airType: selectedSubMenu,
                                    val: val,
                                    level: qa,
                                    unit: 'm',
                                    valObj : d,
                                    measureTime: measureTime,
                                    type : 'water',
                                };

                                naver.maps.Event.addListener(marker, 'click', (event) => {
                                    this.$store.dispatch("SET_SELECTED_MARKER", marker);
                                    this.$refs.rainfallInfoWin.setRainfallInfo(rainfallInfo);
                                });
                                this.addMarkerMap(this.groupName, marker);
                                d.marker = marker;
                            }
                        });
                    }
                }
            }
        },
        loadedAirInfoHandle(content){
            this.openInfoWin(content);
        },
        loadedRainfallInfoHandle(content){
            this.openInfoWin(content);
        },
        loadedMediumMosqInfoHandle(content){
            this.openInfoWin(content);
        },
    },
    mixins: [naverMapShareMixins],
};
</script>
